module.exports = __webpack_public_path__ + "assets/img/38_426_big.0c644239.jpg";